import {
  Col,
  Row,
  Space,
  Table,
  Card,
  Button,
  message,
  Spin,
  Input,
  Select,
  Tag,
  Typography,
  Divider,
} from "antd";
import { useState, useCallback, useMemo, useEffect } from "react";
import {
  ReloadOutlined,
  InboxOutlined,
  FilterOutlined,
  DollarOutlined,
  EditOutlined,
} from "@ant-design/icons";
import { GET_GEO_ALL, HEADERS_EXPORT_BEN } from "../../API/apiUrls";
import axios from "axios";
import MotionHoc from "../../../utils/MotionHoc";
import SetSaleScheduleModal from "./modal/SetSalesChedulemodal";
import RecordSaleResultModal from "./modal/RecordSaleResultModal";
import { SALE_RESULT } from "./modal/SaleResultModal";

const { Option } = Select;
const { Text } = Typography;

// ✅ helper: ฟอร์แมตเงิน
const money = (v) => Number(v || 0).toLocaleString("th-TH");

// ✅ helper mock: บวกเดือนแบบ ISO
function addMonthsISO(startISO, months) {
  const d = new Date(startISO);
  d.setMonth(d.getMonth() + months);
  return d.toISOString().slice(0, 10);
}

// ✅ helper mock: สร้างตารางวันนัด 6 นัด
const mockSchedule = (startISO) =>
  Array.from({ length: 6 }, (_, i) => ({
    round: i + 1,
    date: addMonthsISO(startISO, i),
  }));

const MOCK_CONTRACT_DEBT = {
  "2-0012446": 840000,
  "2-0011000": 250000,
  "1-0009999": 20000,
};

const MOCK_ASSETS = [
  /* ===== สัญญา 2-0012446 : หจก. ทีเอ ทรานสปอร์ต ===== */
  {
    landId: 1334,
    invRoundId: 86,
    loanId: 846,
    contno: "2-0012446",
    assetOnlineId: 1845,
    invId: 577,
    customerId: 2031,
    investigation: 1,
    CUSCOD: "0653560003053",
    SNAM: "หจก.",
    NAME1: "ทีเอ ทรานสปอร์ต (2017)",
    NAME2: "",
    garno: 0,
    LOCAT: "LEX",
    numberLand: "84644",
    typeLand: 1,
    province: "43",
    district: "01",
    subdistrict: "07",
    provDesc: "หนองคาย",
    distDesc: "อ.เมืองหนองคาย",
    subDistDesc: "หาดคำ",
    estimate: 910000,
  },
  {
    landId: 1335,
    invRoundId: 86,
    loanId: 846,
    contno: "2-0012446",
    assetOnlineId: 1845,
    invId: 577,
    customerId: 2031,
    investigation: 2,
    CUSCOD: "0653560003053",
    SNAM: "หจก.",
    NAME1: "ทีเอ ทรานสปอร์ต (2017)",
    NAME2: "",
    garno: 0,
    LOCAT: "LEX",
    numberLand: "84927",
    typeLand: 1,
    province: "43",
    district: "01",
    subdistrict: "07",
    provDesc: "หนองคาย",
    distDesc: "อ.เมืองหนองคาย",
    subDistDesc: "หาดคำ",
    estimate: 420000,
  },
  {
    landId: 1336,
    invRoundId: 86,
    loanId: 846,
    contno: "2-0012446",
    assetOnlineId: 1846,
    invId: 577,
    customerId: 2031,
    investigation: 2,
    CUSCOD: "0653560003053",
    SNAM: "หจก.",
    NAME1: "ทีเอ ทรานสปอร์ต (2017)",
    NAME2: "",
    garno: 0,
    LOCAT: "LEX",
    numberLand: "11023",
    typeLand: 1,
    province: "41",
    district: "01",
    subdistrict: "01",
    provDesc: "อุดรธานี",
    distDesc: "อ.เมืองอุดรธานี",
    subDistDesc: "หมากแข้ง",
    estimate: 180000,
  },
  {
    landId: 1337,
    invRoundId: 86,
    loanId: 846,
    contno: "2-0012446",
    assetOnlineId: 1847,
    invId: 577,
    customerId: 2031,
    investigation: 3,
    CUSCOD: "0653560003053",
    SNAM: "หจก.",
    NAME1: "ทีเอ ทรานสปอร์ต (2017)",
    NAME2: "",
    garno: 0,
    LOCAT: "LEX",
    numberLand: "55012",
    typeLand: 2,
    province: "30",
    district: "01",
    subdistrict: "01",
    provDesc: "นครราชสีมา",
    distDesc: "อ.เมืองนครราชสีมา",
    subDistDesc: "ในเมือง",
    lotNo: "A-03",
    saleSchedule: mockSchedule("2026-02-10"),
    saleResults: {},
    estimate: 280000,
  },
  {
    landId: 1338,
    invRoundId: 86,
    loanId: 846,
    contno: "2-0012446",
    assetOnlineId: 1848,
    invId: 577,
    customerId: 2032,
    investigation: 1,
    CUSCOD: "1451400111735",
    SNAM: "นาง",
    NAME1: "อุบลวัลย์",
    NAME2: "ธีระกูล",
    garno: 1,
    LOCAT: "LEX",
    numberLand: "84700",
    typeLand: 1,
    province: "43",
    district: "01",
    subdistrict: "07",
    provDesc: "หนองคาย",
    distDesc: "อ.เมืองหนองคาย",
    subDistDesc: "หาดคำ",
    estimate: 150000,
  },
  {
    // ✅ แปลงที่ "ขายได้แล้ว" จริง เพื่อให้เห็นว่ามูลค่าทรัพย์คงเหลือ (ยังไม่ขาย)
    // ของสัญญานี้ไม่รวมแปลงนี้ แต่ยอดขายได้ไปหักยอดหนี้คงเหลือแทน
    landId: 1339,
    invRoundId: 86,
    loanId: 846,
    contno: "2-0012446",
    assetOnlineId: 1849,
    invId: 577,
    customerId: 2031,
    investigation: 3,
    CUSCOD: "0653560003053",
    SNAM: "หจก.",
    NAME1: "ทีเอ ทรานสปอร์ต (2017)",
    NAME2: "",
    garno: 0,
    LOCAT: "LEX",
    numberLand: "84955",
    typeLand: 1,
    province: "43",
    district: "01",
    subdistrict: "07",
    provDesc: "หนองคาย",
    distDesc: "อ.เมืองหนองคาย",
    subDistDesc: "หาดคำ",
    lotNo: "A-04",
    saleSchedule: mockSchedule("2026-01-05"),
    saleResults: {
      1: { resultType: SALE_RESULT.SOLD, price: 190000 },
    },
    estimate: 200000,
  },
  /* ===== สัญญา 2-0011000 : นาย สมชาย รุ่งเรือง ===== */
  {
    landId: 2001,
    invRoundId: 90,
    loanId: 901,
    contno: "2-0011000",
    assetOnlineId: 1990,
    invId: 601,
    customerId: 2105,
    investigation: 3,
    CUSCOD: "1100700123455",
    SNAM: "นาย",
    NAME1: "สมชาย",
    NAME2: "รุ่งเรือง",
    garno: 0,
    LOCAT: "LEX",
    numberLand: "20455",
    typeLand: 1,
    province: "50",
    district: "01",
    subdistrict: "01",
    provDesc: "เชียงใหม่",
    distDesc: "อ.เมืองเชียงใหม่",
    subDistDesc: "ศรีภูมิ",
    lotNo: "B-01",
    saleSchedule: mockSchedule("2026-04-01"),
    saleResults: {
      1: {
        resultType: SALE_RESULT.NO_SOLD,
        price: null,
        reason: "ไม่มีผู้เข้าสู้ราคา",
      },
    },
    estimate: 220000,
  },
  {
    // ✅ แปลงที่ขายได้แล้วในสัญญานี้ — ทำให้เห็นกรณี "คาดว่าขาดทุน" เพราะเงินที่ขายได้
    // ไม่พอลดหนี้คงเหลือให้ต่ำกว่ามูลค่าทรัพย์ที่เหลืออยู่
    landId: 2002,
    invRoundId: 90,
    loanId: 901,
    contno: "2-0011000",
    assetOnlineId: 1991,
    invId: 601,
    customerId: 2105,
    investigation: 3,
    CUSCOD: "1100700123455",
    SNAM: "นาย",
    NAME1: "สมชาย",
    NAME2: "รุ่งเรือง",
    garno: 0,
    LOCAT: "LEX",
    numberLand: "30781",
    typeLand: 1,
    province: "90",
    district: "01",
    subdistrict: "01",
    provDesc: "สงขลา",
    distDesc: "อ.เมืองสงขลา",
    subDistDesc: "บ่อยาง",
    lotNo: "B-02",
    saleSchedule: mockSchedule("2026-04-10"),
    saleResults: {
      1: { resultType: SALE_RESULT.SOLD, price: 25000 },
    },
    estimate: 30000,
  },
  /* ===== สัญญา 1-0009999 : นาง วิภา ทองคำ ===== */
  {
    landId: 3001,
    invRoundId: 75,
    loanId: 770,
    contno: "1-0009999",
    assetOnlineId: 1500,
    invId: 540,
    customerId: 1899,
    investigation: 1,
    CUSCOD: "3650400999888",
    SNAM: "นาง",
    NAME1: "วิภา",
    NAME2: "ทองคำ",
    garno: 1,
    LOCAT: "LEX",
    numberLand: "78900",
    typeLand: 1,
    province: "12",
    district: "01",
    subdistrict: "01",
    provDesc: "นนทบุรี",
    distDesc: "อ.เมืองนนทบุรี",
    subDistDesc: "สวนใหญ่",
    estimate: 50000,
  },
];

const STATUS_META = {
  1: { label: "รอประกาศขาย", color: "orange", icon: "📤" },
  2: { label: "รอลงวันนัด", color: "blue", icon: "🕒" },
  3: { label: "มีวันนัดขายแล้ว", color: "green", icon: "🗓️" },
};
const STATUS_KEYS = Object.keys(STATUS_META).map(Number);

const statusOptions = STATUS_KEYS.map((value) => ({
  value,
  ...STATUS_META[value],
}));

const StatusTag = ({ status }) => {
  const m = STATUS_META[status];
  if (!m) return <Tag>ไม่ระบุ</Tag>;
  return <Tag color={m.color}>{m.label}</Tag>;
};

const norm = (v) =>
  String(v ?? "")
    .trim()
    .toLowerCase();
const fullName = (r) =>
  `${r.SNAM || ""}${r.NAME1 || ""} ${r.NAME2 || ""}`.trim();

// ประเภทลูกค้าจาก garno (0 = ผู้เช่าซื้อ, >=1 = คนค้ำ, null = ไม่ระบุ)
const customerType = (garno) =>
  garno === 0 ? "ผู้เช่าซื้อ" : garno ? `คนค้ำที่ ${garno}` : "-";

// ✅ รวมแปลงที่ "ถูกกำหนดวันนัดขายแล้ว" (มี lotNo) ในกลุ่มสัญญาเดียวกัน ให้เป็นราย Lot
// เหตุผลที่ต้องแยกเป็น Lot แทนที่จะรวมทั้งสัญญาเป็น record เดียว: แปลงในสัญญาเดียวกัน
// อาจอยู่คนละจังหวัด (เข้าสำนักงานบังคับคดีคนละแห่ง) หรือถูกนำขึ้นประกาศขายคนละรอบ
// จึงมี "วันนัด" และ "ผลการขาย" ของตัวเอง ไม่สามารถใช้ record เดียวแทนทั้งสัญญาได้
const summarizeLots = (lands) => {
  const map = new Map();
  lands.forEach((l) => {
    if (!l.lotNo) return;
    if (!map.has(l.lotNo)) {
      map.set(l.lotNo, {
        lotNo: l.lotNo,
        contno: l.contno,
        saleSchedule: l.saleSchedule || [],
        saleResults: {},
        lands: [],
        provinces: new Set(),
      });
    }
    const e = map.get(l.lotNo);
    e.lands.push(l);
    if (l.provDesc) e.provinces.add(l.provDesc);
    // ✅ รวมผลการขายจากทุกแปลงใน Lot เดียวกันเข้าด้วยกัน เพราะแปลงในลอตเดียวกัน
    // ใช้ผลการขายชุดเดียวกัน (ดู handleRecordSuccess) — ถ้าไม่รวมตรงนี้ modal
    // แก้ไขผลจะไม่เห็นข้อมูลที่เคยบันทึกไว้
    Object.assign(e.saleResults, l.saleResults || {});
  });
  return [...map.values()].map((e) => ({
    ...e,
    provDesc: e.provinces.size > 1 ? "หลายจังหวัด" : [...e.provinces][0],
  }));
};

const Main = () => {
  const [dataArr, setDataArr] = useState(MOCK_ASSETS);
  const [loading, setLoading] = useState(false);
  const [searchInputTable, setSearchInputTable] = useState("");
  const [processStatus, setProcessStatus] = useState(1);

  // ✅ เปลี่ยนหน่วยของการเลือกจาก "กลุ่มสัญญา" -> "แปลงที่ดินรายตัว"
  // เพราะการนัดขายไม่จำเป็นต้องทำทั้งสัญญาพร้อมกัน (ไม่ใช่ทุกแปลงที่ยึดจะถูก
  // ประกาศขายพร้อมกัน) จึงต้องเลือกได้ละเอียดถึงระดับแปลง
  const [selectedLandIds, setSelectedLandIds] = useState([]);

  const [isScheduleOpen, setIsScheduleOpen] = useState(false);
  const [isRecordOpen, setIsRecordOpen] = useState(false);
  const [recordLot, setRecordLot] = useState(null);

  const [geo, setGeo] = useState({ province: [] });
  const [selZone, setSelZone] = useState(null);
  const [selProvince, setSelProvince] = useState(null);
  const [selDistrict, setSelDistrict] = useState(null);
  const [selSubDistrict, setSelSubDistrict] = useState(null);

  useEffect(() => {
    let isMounted = true;
    const loadGeoData = async () => {
      setLoading(true);
      try {
        const res = await axios.get(GET_GEO_ALL, {
          headers: HEADERS_EXPORT_BEN,
        });
        const d = res.data || {};
        if (isMounted) setGeo({ province: d.province || [] });
      } catch (error) {
        if (error.name !== "CanceledError" && isMounted) {
          message.error("ไม่สามารถโหลดข้อมูลพื้นที่ได้");
        }
      } finally {
        if (isMounted) setLoading(false);
      }
    };
    loadGeoData();
    return () => {
      isMounted = false;
    };
  }, []);

  const provToZone = useCallback(
    (provCode) => {
      const p = geo.province.find(
        (x) => String(x.provCode) === String(provCode),
      );
      return p ? p.groupArea : null;
    },
    [geo.province],
  );

  const provToZoneDesc = useCallback(
    (provCode) => {
      const p = geo.province.find(
        (x) => String(x.provCode) === String(provCode),
      );
      return p ? p.groupDesc : null;
    },
    [geo.province],
  );

  const areaSourceLands = useMemo(() => {
    const q = norm(searchInputTable);
    return dataArr.filter((item) => {
      if (processStatus != null && item.investigation !== processStatus)
        return false;
      if (q) {
        const hay = [item.contno, item.CUSCOD, fullName(item)]
          .map(norm)
          .some((v) => v.includes(q));
        if (!hay) return false;
      }
      return true;
    });
  }, [dataArr, processStatus, searchInputTable]);

  const handleResetArea = useCallback(() => {
    setSelZone(null);
    setSelProvince(null);
    setSelDistrict(null);
    setSelSubDistrict(null);
  }, []);

  const handleResetFilter = useCallback(() => {
    setSearchInputTable("");
    setProcessStatus(null);
    handleResetArea();
    message.info("ล้างตัวกรองสำเร็จ");
  }, [handleResetArea]);

  const hasAreaFilter =
    selZone != null ||
    selProvince != null ||
    selDistrict != null ||
    selSubDistrict != null;

  const matchesLocation = useCallback(
    (rec) => {
      if (!hasAreaFilter) return true;
      if (
        selSubDistrict != null &&
        String(rec.subdistrict) !== String(selSubDistrict)
      )
        return false;
      if (selDistrict != null && String(rec.district) !== String(selDistrict))
        return false;
      if (selProvince != null && String(rec.province) !== String(selProvince))
        return false;
      if (selZone != null && provToZone(rec.province) !== selZone) return false;
      return true;
    },
    [
      hasAreaFilter,
      selZone,
      selProvince,
      selDistrict,
      selSubDistrict,
      provToZone,
    ],
  );

  const filteredLands = useMemo(
    () => areaSourceLands.filter(matchesLocation),
    [areaSourceLands, matchesLocation],
  );

  /**
   * ✅ สถิติระดับ "สัญญา" (ไม่ใช่ระดับแปลง และไม่ผูกกับตัวกรองหน้าจอ)
   *
   * คำนวณจาก dataArr ทั้งหมด (ทุกแปลงของสัญญานั้น ไม่ว่าจะอยู่สถานะไหนหรือถูกกรอง
   * อยู่ในตารางตอนนี้หรือไม่) เพื่อให้ได้ตัวเลขที่ถูกต้อง 2 ตัว:
   *   - recovered: ยอดเงินที่ขายทรัพย์ได้แล้วสะสม (จากทุกแปลง/ทุก Lot ของสัญญานี้)
   *   - remainingCollateral: มูลค่าประเมินของแปลงที่ "ยังไม่ถูกขาย" (ยังเป็นหลักประกัน
   *     ที่เหลืออยู่) รวมกันทั้งสัญญา
   *
   * นี่คือคำตอบของคำถาม "ยอดหนี้คงเหลือก่อนขายทรัพย์" — ต้องดูจากภาพรวมทั้งสัญญา
   * ไม่ใช่แค่แปลงที่กำลังจะนำขึ้นประกาศขายรอบนี้ ไม่เช่นนั้นจะไม่รู้ว่าหนี้ที่เหลือจริง
   * ลดลงไปแล้วเท่าไหร่จากการขายแปลงอื่นก่อนหน้า
   */
  const contractStats = useMemo(() => {
    const map = new Map();
    dataArr.forEach((l) => {
      const key = String(l.contno);
      if (!map.has(key)) map.set(key, { recovered: 0, remainingCollateral: 0 });
      const c = map.get(key);
      const soldEntry = Object.values(l.saleResults || {}).find(
        (r) => r.resultType === SALE_RESULT.SOLD,
      );
      if (soldEntry) {
        c.recovered += Number(soldEntry.price || 0);
      } else {
        c.remainingCollateral += Number(l.estimate || 0);
      }
    });
    return map;
  }, [dataArr]);

  /* ------------------------------------------------------------------ */
  /* Group ตาม เลขสัญญา (Contract Number) — ใช้แสดงภาพรวม/บริบทของสัญญา   */
  /* การนัดขายและผลการขายจริงยังคงอยู่ระดับแปลง/ Lot (ดู summarizeLots)   */
  /* ------------------------------------------------------------------ */
  const groupedTable = useMemo(() => {
    const groups = new Map();
    for (const rec of filteredLands) {
      const key = String(rec.contno);

      if (!groups.has(key)) {
        groups.set(key, {
          groupKey: key,
          contno: rec.contno,
          customerId: rec.customerId,
          CUSCOD: rec.CUSCOD,
          SNAM: rec.SNAM,
          NAME1: rec.NAME1,
          NAME2: rec.NAME2,
          garno: rec.garno,
          provinces: new Set(),
          zones: new Set(),
          lands: [],
        });
      }

      const g = groups.get(key);
      g.lands.push(rec);

      if (rec.provDesc) g.provinces.add(rec.provDesc);
      const zDesc = provToZoneDesc(rec.province);
      if (zDesc) g.zones.add(zDesc);

      // หากเจอผู้เช่าซื้อหลัก (garno === 0) ให้อัปเดตข้อมูลระดับ Group เป็นของผู้เช่าซื้อหลัก
      if (rec.garno === 0) {
        g.SNAM = rec.SNAM;
        g.NAME1 = rec.NAME1;
        g.NAME2 = rec.NAME2;
        g.garno = rec.garno;
        g.customerId = rec.customerId;
        g.CUSCOD = rec.CUSCOD;
      }
    }

    const arr = [...groups.values()].map((g) => {
      const statusCounts = STATUS_KEYS.reduce((acc, k) => {
        acc[k] = 0;
        return acc;
      }, {});
      g.lands.forEach((l) => {
        if (statusCounts[l.investigation] != null)
          statusCounts[l.investigation] += 1;
      });

      // ✅ ยอดหนี้คงเหลือ: มาจากสัญญาเสมอ ไม่ใช่ผลรวมของแปลงที่แสดงอยู่ในตารางนี้
      const stats = contractStats.get(g.contno) || {
        recovered: 0,
        remainingCollateral: 0,
      };
      const contractDebt = MOCK_CONTRACT_DEBT[g.contno] ?? 0;
      const remainingDebt = Math.max(contractDebt - stats.recovered, 0);
      const projectedProfit = stats.remainingCollateral - remainingDebt;

      return {
        ...g,
        count: g.lands.length,
        statusCounts,
        contractDebt,
        recovered: stats.recovered,
        remainingCollateral: stats.remainingCollateral,
        remainingDebt,
        projectedProfit,
        provDescDisplay:
          g.provinces.size > 1 ? "หลายจังหวัด" : [...g.provinces][0],
        zoneDescDisplay: g.zones.size > 1 ? "หลายโซน" : [...g.zones][0],
      };
    });

    arr.sort((a, b) => String(a.contno).localeCompare(String(b.contno), "th"));
    return arr;
  }, [filteredLands, provToZoneDesc, contractStats]);

  const totalLands = useMemo(
    () => groupedTable.reduce((s, g) => s + g.count, 0),
    [groupedTable],
  );

  // ✅ สร้าง "กลุ่มที่ถูกเลือกจริง" จากแปลงที่เลือก (ไม่ใช่ทั้งกลุ่มสัญญา) เพื่อส่งต่อ
  // ให้ modal ตั้งวันนัดขาย — ถ้าเลือกแปลงจากหลายสัญญา จะได้กลุ่มมากกว่า 1 กลุ่ม
  // (แยกวันนัด/ Lot ตามสัญญาให้อัตโนมัติ)
  const selectedGroups = useMemo(() => {
    const result = [];
    groupedTable.forEach((g) => {
      const chosenLands = g.lands.filter((l) =>
        selectedLandIds.includes(l.landId),
      );
      if (chosenLands.length > 0) {
        result.push({ ...g, lands: chosenLands, count: chosenLands.length });
      }
    });
    return result;
  }, [groupedTable, selectedLandIds]);

  // ✅ Checkbox ระดับ "สัญญา" (แถวหลัก) = shortcut สำหรับเลือกทุกแปลง (ที่กำลังแสดง
  // อยู่ในสถานะนี้) ของสัญญานั้นพร้อมกัน แต่ยังคง track ที่ระดับแปลงเสมอ
  const rowSelection = {
    selectedRowKeys: groupedTable
      .filter(
        (g) =>
          g.lands.length > 0 &&
          g.lands.every((l) => selectedLandIds.includes(l.landId)),
      )
      .map((g) => g.groupKey),
    onSelect: (record, selected) => {
      const ids = record.lands.map((l) => l.landId);
      setSelectedLandIds((prev) => {
        const set = new Set(prev);
        ids.forEach((id) => (selected ? set.add(id) : set.delete(id)));
        return [...set];
      });
    },
    onSelectAll: (selected, _selectedRows, changeRows) => {
      setSelectedLandIds((prev) => {
        const set = new Set(prev);
        changeRows.forEach((g) => {
          g.lands.forEach((l) =>
            selected ? set.add(l.landId) : set.delete(l.landId),
          );
        });
        return [...set];
      });
    },
  };

  // ✅ สถานะ "รอประกาศขาย" -> "รอลงวันนัด": แค่เลือกสัญญาที่จะนำขึ้นประกาศขาย
  // ยังไม่ต้องกรอกวันนัด (ขั้นตอนนั้นย้ายไปทำตอนสถานะ "รอลงวันนัด" แทน)
  const handleSelectForAnnouncement = useCallback(() => {
    if (selectedLandIds.length === 0) {
      message.warning("กรุณาเลือกแปลงอย่างน้อย 1 แปลง");
      return;
    }
    const ids = new Set(selectedLandIds);
    setDataArr((prev) =>
      prev.map((land) =>
        ids.has(land.landId) ? { ...land, investigation: 2 } : land,
      ),
    );
    setSelectedLandIds([]);
    message.success("เลือกสัญญาประกาศขายสำเร็จ");
  }, [selectedLandIds]);

  const handleOpenSchedule = useCallback(() => {
    if (selectedLandIds.length === 0) {
      message.warning("กรุณาเลือกแปลงอย่างน้อย 1 แปลง");
      return;
    }
    const distinctContno = new Set(selectedGroups.map((g) => g.contno));
    if (distinctContno.size > 1) {
      message.info(
        `คุณเลือกแปลงจาก ${distinctContno.size} สัญญา ระบบจะแยกกำหนดวันนัดขายให้ตามสัญญาโดยอัตโนมัติ`,
      );
    }
    setIsScheduleOpen(true);
  }, [selectedLandIds.length, selectedGroups]);

  // ✅ สถานะ "รอลงวันนัด" -> "มีวันนัดขายแล้ว": กรอกวันนัดขายให้กลุ่มที่เลือก
  const handleScheduleSuccess = useCallback((payload) => {
    const ids = new Set(payload.landIds);
    setDataArr((prev) =>
      prev.map((land) =>
        ids.has(land.landId)
          ? {
              ...land,
              investigation: 3,
              lotNo: payload.lotNo,
              saleSchedule: payload.saleSchedule,
              saleResults: {},
            }
          : land,
      ),
    );
    setSelectedLandIds([]);
  }, []);

  // ✅ เปิดโมดัลบันทึกผลการขาย "รายล็อต" ไม่ใช่รายสัญญา เพราะ 1 สัญญาอาจมีหลาย Lot
  // ที่มีวันนัด/ผลการขายต่างกัน (ดู summarizeLots)
  const handleOpenRecord = useCallback((lot) => {
    setRecordLot(lot);
    setIsRecordOpen(true);
  }, []);

  const handleRecordSuccess = useCallback(({ group, saleResults }) => {
    const ids = new Set((group.lands || []).map((l) => l.landId));
    setDataArr((prev) =>
      prev.map((land) =>
        ids.has(land.landId) ? { ...land, saleResults } : land,
      ),
    );
  }, []);

  const renderGroupStatus = (g) => {
    const present = STATUS_KEYS.filter((k) => g.statusCounts[k] > 0);
    if (present.length === 0) return <span style={{ color: "#bbb" }}>-</span>;
    return (
      <Space size={4} wrap>
        {present.map((k) => (
          <Tag key={k} color={STATUS_META[k].color}>
            {STATUS_META[k].label} ({g.statusCounts[k]})
          </Tag>
        ))}
      </Space>
    );
  };

  // ✅ ยอดหนี้คงเหลือของ "สัญญา" พร้อมที่มา (หนี้ตั้งต้น − ขายได้แล้ว)
  const renderDebtSummary = (g) => (
    <div style={{ lineHeight: 1.3 }}>
      <Text strong>{money(g.remainingDebt)} บาท</Text>
      <div style={{ fontSize: 11, color: "#999" }}>
        หนี้ตั้งต้น {money(g.contractDebt)}
        {g.recovered > 0 ? ` − ขายได้แล้ว ${money(g.recovered)}` : ""}
      </div>
    </div>
  );

  // ✅ กำไร/ขาดทุน "ที่คาดการณ์" ของทั้งสัญญา = มูลค่าทรัพย์ที่ยังไม่ขาย − หนี้คงเหลือ
  const renderProjectedProfit = (g) => {
    const isProfit = g.projectedProfit >= 0;
    return (
      <div style={{ lineHeight: 1.3 }}>
        <Text strong style={{ color: isProfit ? "#389e0d" : "#cf1322" }}>
          {isProfit ? "คาดว่ากำไร" : "คาดว่าขาดทุน"}{" "}
          {money(Math.abs(g.projectedProfit))} บาท
        </Text>
        <div style={{ fontSize: 11, color: "#999" }}>
          ทรัพย์คงเหลือ {money(g.remainingCollateral)} − หนี้คงเหลือ{" "}
          {money(g.remainingDebt)}
        </div>
      </div>
    );
  };

  // ✅ สรุปผลการขายของ 1 Lot (ไม่ใช่ของทั้งสัญญา)
  const renderLotResult = (lot) => {
    let soldInfo = null;
    const recordedRounds = new Set();
    lot.lands.forEach((l) => {
      Object.entries(l.saleResults || {}).forEach(([round, r]) => {
        recordedRounds.add(round);
        if (r.resultType === SALE_RESULT.SOLD && !soldInfo) {
          soldInfo = { round, price: r.price };
        }
      });
    });
    if (soldInfo) {
      return (
        <Tag color="green">
          ขายได้ (นัด {soldInfo.round}) {money(soldInfo.price)} บาท
        </Tag>
      );
    }
    if (recordedRounds.size > 0) {
      return (
        <Tag color="blue">
          บันทึกแล้ว {recordedRounds.size} นัด (ยังไม่มีผู้ประมูล)
        </Tag>
      );
    }
    return <span style={{ color: "#bbb" }}>ยังไม่บันทึกผล</span>;
  };

  const lotColumns = [
    {
      title: "Lot",
      dataIndex: "lotNo",
      key: "lotNo",
      align: "center",
      width: 90,
    },
    {
      title: "จำนวนแปลงใน Lot",
      key: "landCount",
      align: "center",
      width: 130,
      render: (_, lot) => `${lot.lands.length} แปลง`,
    },
    {
      title: "จังหวัด",
      key: "provDesc",
      align: "center",
      render: (_, lot) => lot.provDesc,
    },
    {
      title: "วันนัดขาย",
      key: "schedule",
      align: "center",
      render: (_, lot) => {
        const today = new Date();
        const upcoming = (lot.saleSchedule || []).find(
          (s) => new Date(s.date) >= today,
        );
        const shown =
          upcoming || lot.saleSchedule?.[lot.saleSchedule.length - 1];
        return shown ? `นัดที่ ${shown.round} (${shown.date})` : "-";
      },
    },
    {
      title: "ผลการขาย",
      key: "result",
      align: "center",
      width: 230,
      render: (_, lot) => renderLotResult(lot),
    },
    {
      title: "จัดการ",
      key: "recordAction",
      align: "center",
      width: 160,
      render: (_, lot) => {
        const hasResults = Object.keys(lot.saleResults || {}).length > 0;
        return (
          <Button
            type="primary"
            ghost={!hasResults}
            size="small"
            icon={hasResults ? <EditOutlined /> : <DollarOutlined />}
            onClick={() => handleOpenRecord(lot)}
          >
            {hasResults ? "แก้ไขผลการขาย" : "บันทึกผลการขาย"}
          </Button>
        );
      },
    },
  ];

  /* --------------- ตารางย่อย: รายละเอียดแต่ละแปลง + รายการ Lot ----------------- */
  const expandedRowRender = (group) => {
    const detailColumns = [
      {
        title: "ลำดับ",
        key: "i",
        align: "center",
        width: 70,
        render: (_, __, i) => i + 1,
      },
      {
        title: "ชื่อเจ้าของทรัพย์",
        key: "ownerName",
        align: "left",
        render: (_, r) => fullName(r),
      },
      {
        title: "ประเภทลูกค้า",
        key: "customerType",
        align: "center",
        render: (_, r) => customerType(r.garno),
      },
      {
        title: "เลขที่ดิน",
        dataIndex: "numberLand",
        key: "numberLand",
        align: "center",
      },
      {
        title: "ประเภท",
        dataIndex: "typeLand",
        key: "typeLand",
        align: "center",
        render: (v) => (v === 1 ? "โฉนด" : v === 2 ? "นส.3" : (v ?? "-")),
      },
      {
        title: "จังหวัด",
        dataIndex: "provDesc",
        key: "provDesc",
        align: "center",
      },
      {
        title: "อำเภอ",
        dataIndex: "distDesc",
        key: "distDesc",
        align: "center",
      },
      {
        title: "ตำบล",
        dataIndex: "subDistDesc",
        key: "subDistDesc",
        align: "center",
      },
      {
        title: "ราคาประเมิน (กรมบังคับคดี)",
        dataIndex: "estimate",
        key: "estimate",
        align: "right",
        render: (v) => money(v),
      },
      {
        // ✅ ทดแทนคอลัมน์ "กำไร/ขาดทุน" รายแปลงเดิม (ซึ่งอิงหนี้รายแปลงที่ไม่มีอยู่จริง)
        // ด้วยตัวเลขที่สื่อความหมายจริง: หนี้คงเหลือทั้งสัญญา แบ่งตามสัดส่วนราคาประเมินแปลงนี้
        title: "สัดส่วนต่อหนี้คงเหลือ (ยอดเงิน)",
        key: "shareOfDebt",
        align: "right",
        width: 150,
        render: (_, r) => {
          const totalEstimate = group.lands.reduce(
            (s, l) => s + Number(l.estimate || 0),
            0,
          );
          if (!group.remainingDebt || !totalEstimate)
            return <span style={{ color: "#bbb" }}>-</span>;
          const debtShare =
            (Number(r.estimate || 0) / totalEstimate) * group.remainingDebt;
          return money(debtShare);
        },
      },
      {
        title: "Lot",
        dataIndex: "lotNo",
        key: "lotNo",
        align: "center",
        render: (v) => v || <span style={{ color: "#bbb" }}>-</span>,
      },
      {
        title: "สถานะการสืบ",
        key: "inv",
        align: "center",
        render: (_, r) => <StatusTag status={r.investigation} />,
      },
    ];

    // ✅ ผูก checkbox รายแปลงเข้ากับ state ส่วนกลาง (selectedLandIds) จริง ๆ
    // (โค้ดเดิมมี checkbox นี้แต่ยังไม่ได้ผูกกับ state ใด ๆ แค่ console.log)
    const rowSelectionChild = {
      selectedRowKeys: group.lands
        .filter((l) => selectedLandIds.includes(l.landId))
        .map((l) => l.landId),
      onChange: (keys) => {
        setSelectedLandIds((prev) => {
          const otherIds = prev.filter(
            (id) => !group.lands.some((l) => l.landId === id),
          );
          return [...otherIds, ...keys];
        });
      },
    };

    const lotRows = summarizeLots(group.lands);

    return (
      <>
        {lotRows.length > 0 && (
          <>
            <Text strong style={{ fontSize: 12, color: "#666" }}>
              รายการนัดขาย (Lot) ของสัญญานี้
            </Text>
            <Table
              size="small"
              columns={lotColumns}
              dataSource={lotRows}
              rowKey={(r) => r.lotNo}
              pagination={false}
              style={{ marginTop: 8, marginBottom: 16 }}
            />
            <Divider style={{ margin: "8px 0" }} />
          </>
        )}
        <Table
          size="small"
          columns={detailColumns}
          dataSource={group.lands}
          rowKey={(r) => r.landId}
          pagination={false}
          rowSelection={
            processStatus === 1 || processStatus === 2
              ? rowSelectionChild
              : null
          }
          style={{ background: "#fafafa", borderRadius: 8 }}
        />
      </>
    );
  };

  /* --------------------- คอลัมน์หลัก (parent) --------------------- */
  const columns = [
    {
      title: "ลำดับ",
      key: "index",
      align: "center",
      width: 70,
      render: (_, __, index) => index + 1,
    },
    {
      title: "เลขสัญญา",
      dataIndex: "contno",
      key: "contno",
      align: "center",
      width: 140,
      sorter: (a, b) => String(a.contno).localeCompare(String(b.contno), "th"),
      defaultSortOrder: "ascend",
      render: (v) => <Text strong>{v}</Text>,
    },
    {
      title: "ชื่อ-นามสกุลเจ้าของทรัพย์ (หลัก)",
      key: "fullName",
      align: "left",
      render: (_, g) => fullName(g),
    },
    {
      title: "ประเภทลูกค้า",
      key: "garno",
      align: "left",
      render: (_, g) => customerType(g.garno),
    },
    {
      title: "โซน",
      key: "zone",
      align: "center",
      render: (_, g) =>
        g.zoneDescDisplay ? (
          <Tag color={g.zoneDescDisplay === "หลายโซน" ? "orange" : "geekblue"}>
            {g.zoneDescDisplay}
          </Tag>
        ) : (
          <span style={{ color: "#bbb" }}>-</span>
        ),
    },
    {
      title: "จังหวัด",
      dataIndex: "provDescDisplay",
      key: "province",
      align: "center",
      render: (v) =>
        v === "หลายจังหวัด" ? <Text type="warning">{v}</Text> : v,
    },
    {
      title: "จำนวนแปลง",
      key: "count",
      align: "center",
      width: 110,
      render: (_, g) => <Tag color="purple">{g.count} แปลง</Tag>,
    },
    {
      title: "มูลค่าทรัพย์คงเหลือ (ยังไม่ขาย)",
      key: "remainingCollateral",
      align: "right",
      width: 170,
      sorter: (a, b) => a.remainingCollateral - b.remainingCollateral,
      render: (_, g) => money(g.remainingCollateral),
    },
    {
      title: "ยอดหนี้คงเหลือ (สัญญา)",
      key: "remainingDebt",
      align: "right",
      width: 190,
      sorter: (a, b) => a.remainingDebt - b.remainingDebt,
      render: (_, g) => renderDebtSummary(g),
    },
    {
      title: "กำไร/ขาดทุนที่คาดการณ์",
      key: "projectedProfit",
      align: "right",
      width: 220,
      sorter: (a, b) => a.projectedProfit - b.projectedProfit,
      render: (_, g) => renderProjectedProfit(g),
    },
    {
      title: "สถานะการสืบ",
      key: "investigation",
      align: "center",
      width: 180,
      render: (_, g) => renderGroupStatus(g),
    },
  ];

  const stepBadge = (n, color) => (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        width: 22,
        height: 22,
        borderRadius: "50%",
        background: color,
        color: "#fff",
        fontSize: 12,
        fontWeight: 700,
      }}
    >
      {n}
    </span>
  );

  return (
    <Spin spinning={loading} size="large" tip="กำลังโหลดข้อมูล...">
      <Card
        style={{
          marginBottom: 8,
          borderRadius: 12,
          border: "1px solid #ffcb05",
          background: "#fffdf0",
        }}
      >
        <Row align="middle" gutter={[8, 8]}>
          <Col xs={24} md={10}>
            <Space size={8} align="center">
              {stepBadge("1", "#efa420")}
              <FilterOutlined style={{ color: "#efa420" }} />
              <Text strong style={{ color: "#efa420" }}>
                เลือกสถานะงาน
              </Text>
              <Select
                size="large"
                style={{ minWidth: 210 }}
                placeholder="เลือกสถานะ"
                value={processStatus}
                allowClear
                onChange={(v) => setProcessStatus(v ?? null)}
                optionLabelProp="label"
              >
                {statusOptions.map(({ value, icon, label }) => (
                  <Option key={value} value={value} label={`${icon} ${label}`}>
                    <Space>
                      <span>{icon}</span>
                      <span>{label}</span>
                    </Space>
                  </Option>
                ))}
              </Select>
            </Space>
          </Col>

          <Col xs={24} md={14} style={{ textAlign: "end" }}>
            <Space size={10} wrap>
              {processStatus === 1 && (
                <Button
                  type="primary"
                  ghost
                  icon={<InboxOutlined />}
                  disabled={selectedLandIds.length === 0}
                  onClick={handleSelectForAnnouncement}
                >
                  📋 เลือกสัญญาประกาศขาย ({selectedLandIds.length})
                </Button>
              )}

              {processStatus === 2 && (
                <Button
                  type="primary"
                  ghost
                  danger
                  icon={<InboxOutlined />}
                  disabled={selectedLandIds.length === 0}
                  onClick={handleOpenSchedule}
                >
                  📥 กำหนดวันนัดประกาศขาย ({selectedLandIds.length})
                </Button>
              )}

              <Input
                placeholder="ค้นหาเลขสัญญา, ชื่อ"
                value={searchInputTable}
                onChange={(e) => setSearchInputTable(e.target.value)}
                style={{ width: 240, borderRadius: 8 }}
                size="small"
                allowClear
                suffix={<span>🔍</span>}
              />
              <Button
                icon={<ReloadOutlined />}
                onClick={handleResetFilter}
                size="large"
                style={{
                  borderRadius: 8,
                  backgroundColor: "#fff1f0",
                  borderColor: "#ffa39e",
                  color: "#cf1322",
                }}
              >
                ล้างตัวกรอง
              </Button>
            </Space>
          </Col>
        </Row>
      </Card>

      <Card>
        <Table
          size="small"
          columns={columns}
          dataSource={groupedTable}
          rowKey={(g) => g.groupKey}
          scroll={{ x: 1600 }}
          rowSelection={
            processStatus === 1 || processStatus === 2 ? rowSelection : null
          }
          expandable={{
            expandedRowRender,
            rowExpandable: (g) => g.lands?.length > 0,
            defaultExpandAllRows: processStatus === 2,
          }}
          pagination={{
            defaultPageSize: 10,
            showSizeChanger: true,
            showTotal: (total) => `ทั้งหมด ${total} กลุ่มสัญญา`,
            pageSizeOptions: ["10", "20", "50", "100"],
          }}
          footer={() => (
            <p style={{ margin: 0 }}>
              จำนวนกลุ่มสัญญา {groupedTable.length} | จำนวนแปลงทั้งหมด{" "}
              {totalLands}
              {(processStatus === 1 || processStatus === 2) &&
                ` | เลือก ${selectedLandIds.length} แปลง`}
              <br />
              <Text type="secondary" style={{ fontSize: 11 }}>
                * ยอดหนี้คงเหลือคำนวณจากยอดหนี้ตั้งต้นของทั้งสัญญา
                หักด้วยยอดที่ขายทรัพย์ได้แล้วสะสมของทุกแปลง/ทุก Lot ในสัญญานั้น
                ไม่ใช่เฉพาะแปลงที่แสดงในตารางตามตัวกรองปัจจุบัน
              </Text>
            </p>
          )}
        />
      </Card>

      <SetSaleScheduleModal
        open={isScheduleOpen}
        onClose={setIsScheduleOpen}
        selectedGroups={selectedGroups}
        onSuccess={handleScheduleSuccess}
      />

      <RecordSaleResultModal
        open={isRecordOpen}
        onClose={setIsRecordOpen}
        group={recordLot}
        onSuccess={handleRecordSuccess}
      />
    </Spin>
  );
};

const MainSelectAssetAnnouncement = MotionHoc(Main);
export default MainSelectAssetAnnouncement;
